export default __webpack_public_path__ + "static/media/reduce-size.e5af2bb8.svg";